$(document).ready(function() {
  var $collectionNavSwiper = $('.collection-navigation-swiper');

  if ( $collectionNavSwiper.length ) {
    var collectionNavSwiper = new Swiper('.collection-navigation-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 12,
      loop: false,
      freeMode: true,
    });
  }

  collapsibleDescriptionArea();

  function collapsibleDescriptionArea() {
    var $description = $('.collection-description');
    var $button = $description.next('.read-more');
    var lineHeight = $description.css('line-height');
    var paddingTop = $description.css('padding-top');
    var minHeight = lineHeight.replace('px', '')*1 + paddingTop.replace('px', '')*1;

    if ( $description.prop('scrollHeight') > minHeight ) {
      $description.addClass('collapsible');
      $button.on('click', function() {        
        if ( $description.hasClass('active') ) {
          $description.removeClass('active');
          $button.text('Read More');
        } else {
          $description.addClass('active');
          $button.text('Read Less');
        }
      })
    }
  }
});